<div class="container-fluid clerk-search-page">
  <div class="row">

    <!-- Facets sidebar -->
    <div *ngIf="hasFacets" class="col-12 col-md-3 px-0 gung-filters align-self-start">
      <div class="filter-header px-4 py-3">
        <i class="fas fa-sliders-h pr-2"></i>
        <span class="font-weight-bold" translate>FILTERS</span>
      </div>
      <div *ngFor="let facet of facetEntries" class="filter-list-item">
        <div
          class="filter-header px-4 py-3"
          [ngClass]="{ isActive: selectedFilters[facet.key] != null, isOpen: openFacets[facet.key] }"
          (click)="openFacets[facet.key] = !openFacets[facet.key]"
        >
          <i class="fa pr-2" [ngClass]="{ 'fa-chevron-down': !openFacets[facet.key], 'fa-chevron-up': openFacets[facet.key] }"></i>
          {{ facet.key | translate }}
          <span *ngIf="selectedFilters[facet.key] != null">(1)</span>
        </div>
        <div class="filter-body" [ngbCollapse]="!openFacets[facet.key]">
          <div class="px-4 pt-3">
            <ul>
              <li
                *ngFor="let item of facet.items"
                class="filter-option mb-1 p-0"
                [ngClass]="{ selected: selectedFilters[facet.key] === item.value }"
                (click)="selectFacet(facet.key, item.value)"
              >
                <span class="w-100 d-inline-flex align-items-center gap-1">
                  <i class="far flex-shrink-0" [ngClass]="{ 'fa-square': selectedFilters[facet.key] !== item.value, 'fa-check-square': selectedFilters[facet.key] === item.value }"></i>
                  <span class="flex-grow-1">{{ item.name }}</span>
                  <span class="flex-shrink-0 text-muted">{{ item.count }}</span>
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Product grid -->

    <div class="col-12" [class.col-md-9]="hasFacets">
      <h2 class="clerk-search-page-title">{{ 'SEARCH_RESULTS' | translate }}</h2>

      <div *ngIf="isLoading && products.length === 0" class="text-center p-5">
        <i class="fa-regular fa-spinner fa-spin fa-2x"></i>
      </div>

      <ng-template #layoutHost></ng-template>

      <div *ngIf="hasMore" class="text-center mt-4">
        <button class="btn btn-outline-secondary" (click)="loadMore()" [disabled]="isLoading">
          <i *ngIf="isLoading" class="fa-regular fa-spinner fa-spin me-1"></i>
          {{ 'GUNG_PRODUCT_LIST_LOAD_MORE' | translate: { limit: products.length, total: totalCount } }}
        </button>
      </div>
    </div>

  </div>
</div>
